__turbopack_context__.v({
  "Pretitle": "Pretitle-module-scss-module__MfhOha__Pretitle",
  "Title": "Pretitle-module-scss-module__MfhOha__Title",
});
